/**
 * This data represents all filters available at a specific Report;
 */
export default [
  {
    id: 'BmGroup',
    name: 'BmGroup',
    color: '#FFD700',
    options: [
      {
        text: 'vs US Univ',
        value: 'USUniv',
        default: true,
      },
      {
        text: 'vs Global Univ',
        value: 'GBLUniv',
      },
    ],
  },
  {
    id: 'MultiYear',
    name: 'MultiYear',
    color: 'yellow',
    options: [
      {
        text: '5 year period',
        value: '5',
        default: true,
      },
      {
        text: '4 year period',
        value: '4',
        color: 'orange',
      },
      {
        text: '3 year period',
        value: '3',
        color: 'gray',
      },
      {
        text: '2 year period',
        value: '2',
      },
      {
        text: '1 year period',
        value: '1',
      },
    ],
  },
  {
    id: 'PerfFees',
    name: 'PerfFees',
    color: '#00FF7F',
    options: [
      {
        text: 'Include Performance Fees',
        value: 'InclPerf',
        default: true,
      },
      {
        text: 'Exclude Performance Fees',
        value: 'ExclPerf',
      },
    ],
  },
  {
    id: 'TimePeriod',
    name: 'TimePeriod',
    color: 'green',
    options: [
      {
        text: '1 year',
        value: '1',
        default: true,
      },
      {
        text: '2 year',
        value: '2',
      },
    ],
  },
  {
    id: 'PerformFee_YesNo',
    name: 'PerformFee_YesNo',
    type: 'dropdown',
    color: '#d74b6a',
    options: [
      {
        value: 'Yes',
        text: 'Yes',
      },
      {
        value: 'No',
        text: 'No',
      },
    ],
  },
  {
    id: 'FeeBase_vs_NAV',
    name: 'FeeBase_vs_NAV',
    type: 'dropdown',
    color: '#544bd7',
    options: [
      {
        value: 'Option1',
        text: 'Option1',
      },
      {
        value: 'Option2',
        text: 'Option2',
      },
    ],
  },
  {
    id: 'ValueAdded_YesNo',
    name: 'ValueAdded_YesNo',
    type: 'dropdown',
    color: '#4bcbd7',
    options: [
      {
        value: 'Yes',
        text: 'Yes',
      },
      {
        value: 'No',
        text: 'No',
      },
    ],
  },
]
